import { Box, Text } from '@chakra-ui/react';

export const BadgePreview = () => {
  return (
    <Box>
      <Text>BadgePreview - Coming soon</Text>
    </Box>
  );
};
